// jQuery(document).ready(function($) {
//     if(!is_dev) {
//         return;
//     }
//     open_settings(function(elm, popup) {
//         let check = 0;
//         check = setInterval(() => {
//             if ($('body[data-is-loading]').length === 0) {
//                 clearInterval(check);
//                 $('a#link-to-documents').click();
//             }
//         }, 500);
//
//     });
// });
function open_settings_tab(tab) {
    open_settings((elm) => {
        const check = setInterval(() => {
            const link = elm.find(`a#link-to-${tab}`);
            if (link.length > 0) {
                link.click();
                clearInterval(check);
            }
        }, 10);
    })
}
function open_settings(callback) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/settings/',
        onOpen: function(elm, popup) {
            if(callback !== undefined) {
                callback(elm, popup);
            }

            elm.find('[data-document-type-selector]').documentTypeSelector();

            email_settings(elm);

            elm.find('form').ajaxFormSubmit(function () {
                //complete
                elm.doneLoading();
                elm.squdeReloadAjaxPopup();
                squde_flash("Instellingen gewijzigd");
                if (document.closeWindow) popup.close();
            },function () {
                //error
                elm.doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            },function () {
                //before submit
                elm.isLoading();
            });

            $('select.default_value_toggler').trigger('change');

            load_migration_screen(elm, popup);
            load_course_status_screen(elm, popup);
        }
    });
    return false;
}
function email_settings(elm) {
    const $ = jQuery.noConflict();

    elm.find('.mail-settings-toggle').change(function() {
        const name = $(this).attr('name');
        const type = name.substr(4);

        $(this).parents('.sub-screen-wrapper').find('.row.' + type + '-settings').toggle($(this).is(':checked'));

        if ($(this).is(':checked')) {
            elm.find('.mail-settings-toggle:not([name="' + name + '"])').removeAttr('checked').trigger('change');
        }
    });

    elm.find('a.azure-sign-in').click(function() {
        const url = $(this).attr('href');

        const width = 400;
        const height = 650;
        const left = ($(window).width()/2)-(width/2);
        const top = ($(window).height()/2)-(height/2);
        window.open(url, 'Microsoft OAuth', 'fullscreen=0,menubar=0,toolbar=0,height=' + height + ',width=' + width + ',left=' + left + ',top=' + top);

        const waitForStorage = (e) => {
            if (e.key === 'msOAuth' || e.key === 'googleOAuth') {
                $('.reveal').squdeReloadAjaxPopup();
                window.removeEventListener("storage", waitForStorage);
                window.localStorage.removeItem(e.key);
            }
        };

        window.addEventListener("storage", waitForStorage);

        return false;
    });
}
function load_course_status_screen(elm, popup) {
    const $ = jQuery.noConflict();
    elm.find('.color-switch').change(function(e, automatic) {
        const checked = $(this).is(':checked');
        $(this).parents('.column').next().find('label').toggle(checked);
        if (!automatic) {
            if (checked) {
                $(this).parents('.row:first').find('[type="color"]:visible').focus();
                $(this).parents('.row:first').find('[type="color"]:visible').click();
            } else {
                $(this).parents('.row:first').find('[type="color"]:visible').blur();
            }
        }
    }).trigger('change', [true]);
}
function load_usage_screen(sender) {
    var $ = jQuery.noConflict();


    var elm = $(sender);
    if(elm.is(':not(:visible)')) {
        return;
    }

    var id = "disk-progress-wrapper";

    var wrapper = elm.find('#'+id);
    if(wrapper.find('svg').length > 0) {
        return;
    }

    var w = wrapper.width();
    var h = wrapper.height();
    var stroke_width = 30;

    var amount = wrapper.attr('data-progress');

    var paper = Raphael(document.getElementById(id), w, h);
    var back_circle = paper.circle(w/2, h/2, (h/2 - stroke_width / 2));
    back_circle.attr({fill: 'rgba(0,0,0,0)', stroke: '#ddd', 'stroke-width': stroke_width});

    paper.customAttributes.arc = function(xloc, yloc, value, total, R) {
        var alpha = 360 / total * value,
            a = (90 - alpha) * Math.PI / 180,
            x = xloc + R * Math.cos(a),
            y = yloc - R * Math.sin(a),
            path;
        if (total == value) {
            path = [
                ["M", xloc, yloc - R],
                ["A", R, R, 0, 1, 1, xloc - 0.01, yloc - R]
            ];
        } else {
            path = [
                ["M", xloc, yloc - R],
                ["A", R, R, 0, +(alpha > 180), 1, x, y]
            ];
        }
        return {
            path: path
        };
    };

    var y = 0;
    var x = 0;

    var color = wrapper.css('color');

    var theArc = paper.path().attr({
        "stroke": color,
        "stroke-width": stroke_width,
        arc: [x, y, 0, 100, (h/2 - stroke_width / 2)]
    });



    //theArc.rotate(180, 100, 100).animate({
    theArc.rotate(180, 100, 100).animate({
        arc: [x, y, amount, 100, (h/2 - stroke_width / 2)]
    }, 1000, 'bounce', function() {
    });
}
function load_migration_screen(elm, popup) {
    var $ = jQuery.noConflict();
    elm.find('.sub-screen-wrapper#migration_assistant form').unbind('submit').submit(function(e) {
        e.preventDefault();
        //First, check connection
        var form = $(this);
        elm.isLoading();
        $.get("/settings/migration/check_connection", form.serializeJSON(), function(data) {
            elm.doneLoading();
            if(typeof data == 'object') {
                squde_flash("Verbinding met database gemaakt", "success");

                window.onbeforeunload = confirmExit;
                function confirmExit() {
                    return "Je kunt dit scherm beter niet sluiten";
                }
                $('body').append("<div class='no-click-zone'></div>");
                $('.no-click-zone').css({
                    'z-index': 999999,
                    'width': '100vw',
                    'height': '100vh',
                    'position': 'fixed',
                    'top': 0,
                    'left': 0
                });

                var sendData = form.serializeJSON();
                //var todo = [
                //    'settings',
                //    'companies',
                //    //'contacts',
                //    'courses',
                //    //'schedule',
                //    'contracts',
                //]
                var todo = sendData.todo;
                todo.push('finish');
                var todo_trans = {
                    'settings': 'Instellingen',
                    'companies': 'Bedrijven',
                    'contacts': 'Personen',
                    'courses': 'Cursussen',
                    'schedule': 'Planning',
                    'contracts': 'Herhalingscontracten',
                    'finish': 'Afronden...'
                }
                var done = [];
                elm.find('.show-during-migration').show();
                form.find('input.button').hide();
                elm.find('.loader-indicator').isLoading();
                var current_item = function(str) {
                    elm.find('.current-item').html(str);
                }.bind(elm);
                var set_progress = function(progress) {
                    progress = Math.round(progress);
                    elm.find('.progress-bar').attr('data-progress', progress);
                }.bind(elm);

                current_item("Instellingen");
                set_progress(0);

                var get_data_for_part = function(what_data, part, max, retry) {
                    if (retry === undefined) {
                        retry = true;
                    }
                    sendData.chunks = 10;

                    $.ajax({
                        url: "/settings/migration/get_data/"+what_data+"/"+part,
                        data: sendData,
                        success: function(data) {
                            console.log(data[0]);
                            current_item(data[1]);

                            if(part >= max || data[0].length < sendData.chunks) {
                                done.push(what_data);
                                var progress = done.length / todo.length * 100;
                                set_progress(progress);
                                if(progress < 100) {
                                    get_this_data(todo[todo.indexOf(what_data)+1]);
                                } else {
                                    elm.find('.loader-indicator').doneLoading();
                                    $('.no-click-zone').remove();
                                    current_item("Migratie voltooid!");
                                    window.onbeforeunload = false;
                                }
                            } else {
                                //There is more to it
                                var cur_perc = done.length / todo.length;
                                var perc_step = 100 / todo.length;
                                var sub_perc = part / max;
                                cur_perc = cur_perc + ((perc_step / 100) * sub_perc);
                                set_progress(cur_perc * 100);
                                get_data_for_part(what_data, part + sendData.chunks, max);
                            }
                        },
                        error: function(a,b,c) {
                            if(what_data == "clients" && c == "Failed Dependency") {
                                $.ajax({
                                    url: "/settings/migration/get_data/"+what_data+"/getDoubles",
                                    dataType: 'JSON',
                                    data: sendData,
                                    success: function(data) {
                                        var client_numbers = data.join(', ');
                                        alert("U heeft dubbele debiteurnummers in het oude programma.\nDit is niet toegestaan in deze software.\nHet gaat om de volgende debiteurnummers: "+client_numbers);
                                    },
                                    error: function(a,b,c) {
                                        squde_flash("Er is een probleem opgetreden. Neem contact op met onze helpdesk.","alert");
                                    }
                                });

                            } else {
                                if (retry === false) {
                                    squde_flash("Er is een probleem opgetreden. Neem contact op met onze helpdesk.","alert");
                                } else {
                                    setTimeout(function() {
                                        get_data_for_part(what_data, part, max, false);
                                    }, 2000);
                                }
                            }
                            elm.find('.show-during-migration').hide();
                            form.find('input.button').show();
                            elm.find('.loader-indicator').doneLoading();

                            window.onbeforeunload = false;
                            $('.no-click-zone').remove();
                        }
                    });
                }

                var get_this_data = function(what_data) {
                    $.ajax({
                        url: "/settings/migration/get_data/"+what_data,
                        data: form.serializeJSON(),
                        success: function(data) {
                            current_item(todo_trans[what_data]);
                            get_data_for_part(what_data, 1, data);
                        },
                        error: function(a,b,c) {
                            squde_flash("Er is een probleem opgetreden. Neem contact op met onze helpdesk.","alert");
                            elm.find('.show-during-migration').hide();
                            form.find('input.button').show();
                            elm.find('.loader-indicator').doneLoading();

                            window.onbeforeunload = false;
                            $('.no-click-zone').remove();
                        }
                    });
                }
                get_this_data(todo[0]);

            } else {
                squde_flash("Kan geen verbinding met de database krijgen", "alert");
            }
        });


    });
}

function add_oauth_client(hasToConfirm = false, name = 'ClientCredentials Grant Client') {
    const $ = jQuery.noConflict();

    const createClient = async () => {
        const popup = $('.reveal:last:visible');
        popup.isLoading();

        try {
            await $.post('/settings/api/createClient', { name });
        } catch (e) {
            console.error(e);
            squde_flash('Er ging iets mis', 'alert');
        }
        reload_location_if_needed(false, () => {
            popup.doneLoading();
        });
    }

    if (!hasToConfirm) {
        createClient();
    } else {
        confirm('Weet u dit zeker? Alle huidige koppelingen zullen hierna niet meer werken.', createClient);
    }

    return false;
}
function delete_oauth_key(client_id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    confirm("Weet u zeker dat u de sleutel '"+name+"' wilt verwijderen?",function() {
        $.ajax({
            url: '/settings/api/deleteClient/' + client_id,
            type: 'POST',
            success: function() {
                jQuery('table.clients-table').reloadThisElement();
            }
        })
    })
}
function read_css(elm, sentFile) {
    const $ = jQuery.noConflict();
    const container = elm.parents('.reveal');
    container.isLoading();
    const file = sentFile;
    const read = new FileReader();

    read.readAsBinaryString(file);

    read.onloadend = function(){
        const editor = elm.parents('.row:first').parents('.row:first').find('.ace_editor')[0].env.editor;
        editor.setValue(read.result);

        container.doneLoading();
    }
}
